import { PagingResult } from 'models';
import { client, queryStringifyObject } from 'shared';
import moment from 'moment';
import { UpperDaysOfWeek } from 'shared/Dates';
import { ISpotlightWorker } from 'parent-portal/home/Models/DashboardData';

export interface ProviderSelection {
    name: string;
    id: number;
}

export async function getPastWorkers(
    jobTimes?: JobTimes,
    addresses?: number[],
    includeAllPastWeekBooked?: boolean,
    includeFrozen?: boolean,
): Promise<PastWorkerDTO[]> {
    const sitterChoices = await client('api/past-workers/', {
        method: 'POST',
        body: {
            job_times: jobTimes,
            addresses,
            include_all_past_week_booked: includeAllPastWeekBooked,
            include_frozen: includeFrozen,
        },
    });
    return sitterChoices.past_sitters;
}

export interface PastWorkerDTO {
    first_name: string;
    last_name: string;
    babysitter_id: number;
    id: number;
    status?: string;
}

export interface JobTimes {
    start: moment.Moment | null;
    end: moment.Moment | null;
    days_of_week: Record<UpperDaysOfWeek, { selected: boolean }>;
}

export function getPreferredWorkers(
    page = 1,
    addresses?: number[],
    jobTimes?: JobTimes,
    pageSize = 5,
): Promise<PagingResult<PreferredWorkerDTO>> {
    const addressString = addresses && addresses.length > 0 ? addresses.join(',') : undefined;
    const queryString = queryStringifyObject({});
    return client(`api/preferred-worker/workers-with-status/?${queryString}`, {
        method: 'POST',
        body: {
            page,
            page_size: pageSize,
            addresses: addressString,
            distinct_workers: true,
            job_times: jobTimes,
        },
    });
}

export interface PreferredWorkerDTO {
    id: number;
    user: {
        first_name: string;
        last_name: string;
        id: number;
    };
    business_location: {
        id: number;
        name: string;
    };
    business: {
        id: number;
        name: string;
    };
    status?: string;
}

export interface PreferredJobSitterDTO {
    preferred_sitters: {
        sitter: number;
        spotlight: boolean;
    }[];
}

export function convertPreferredSitterObject(
    preferredProviders: ProviderSelection[],
    pastProviders: ProviderSelection[],
    spotlightWorkers?: Omit<ISpotlightWorker, 'credentials'>[],
): PreferredJobSitterDTO {
    const allPreferred = [...preferredProviders, ...pastProviders];
    return {
        preferred_sitters: [
            ...allPreferred.map((preferredProvider: ProviderSelection) => ({
                sitter: preferredProvider.id,
                spotlight: false,
            })),
            ...(spotlightWorkers?.map((spotlightWorker: Omit<ISpotlightWorker, 'credentials'>) => ({
                sitter: spotlightWorker.id,
                spotlight: true,
            })) || []),
        ],
    };
}
